export default __webpack_public_path__ + "static/media/factory__12.8d6df8ee.jpg";